import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";

import Context from '../../context/contextMaterial';

const Material = ({ match }) => {
  return (
    <Context>
      <Switch>
        <Route path={`${match.url}/especialidades`} component={asyncComponent(() => import('./MaterialManagement/index'))} />
        <Route path={`${match.url}/casos-clinicos/:idsubEspecialiad`} component={asyncComponent(() => import('./clinicalCases/index'))} />
      </Switch>
    </Context>
  )
}
export default Material
